import React, {useState} from 'react';
import {Link, useParams} from "react-router-dom";
import DynamicWebServiceDrivenForm from "../../platform/webform/DynamicWebServiceDrivenForm";
import {Card} from "../../components/Card";
import {createInternationalizationPrefixer} from "../../platform/i18n/i18n";
import {AuthLanguageSwitcher} from "../account/AuthLanguageSwitcher";
import "../account/auth-forms.css";

const t = createInternationalizationPrefixer("SetNewPasswordPage");

const FORM = "form";
const SUCCESS = "success";

export function SetNewPasswordPage() {
    const {code} = useParams();
    const [viewState, setViewState] = useState<string>(FORM);

    const bodyContent = viewState === FORM
        ? <SetPasswordForm code={code} onSuccess={() => setViewState(SUCCESS)}/>
        : <SuccessMessage/>;

    return <div>
        <div className="account-pages mt-5 mb-5">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6 col-xl-5">
                        <AuthLanguageSwitcher/>
                        <Card>
                            <ResetHeader/>
                            {bodyContent}
                        </Card>
                    </div>
                </div>
            </div>
        </div>
        <footer className="footer footer-alt text-dark text-center">
            {(new Date().getFullYear())} &copy; Wentech
        </footer>
    </div>;
}

function ResetHeader() {
    return <div className="text-center">
        <div className="clearfix text-center pt-20 pb-20">
            <img src="/img/wentech_logo.svg" width="60%" alt="logo"/>
            <div className="text-muted mt-3">
                <h3>Optisel 2</h3>
                {t("Ustawienie nowego hasła")}
            </div>
        </div>
    </div>;
}

function SetPasswordForm({code, onSuccess}: { code: string | undefined, onSuccess: () => void }) {
    const endpoint = "/api/password-reset/set/" + code;
    return <div className="auth-wide-form">
        <DynamicWebServiceDrivenForm
            dslUrl={endpoint}
            submissionUrl={endpoint}
            submitLabel={t("Ustaw nowe hasło")}
            successHandler={onSuccess}/>
    </div>;
}

function SuccessMessage() {
    return <div className="text-center">
        <p className="mt-3">{t("Hasło zostało zmienione. Możesz się teraz zalogować.")}</p>
        <Link to="/sign-in" className="btn btn-link mt-2">{t("Powrót do logowania")}</Link>
    </div>;
}
